<template>
	<div class="border-top">
		<SOFilterTitle :title="'Status Transaksi'" :diterapkan="diterapkan" :id="id"/>
		<SOFilterCheckboxSkeleton v-if="pageSetting.loading" />
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id" v-if="!pageSetting.loading">
			<SOInputCheckbox
				:checkboxes="statusTransaksi"
				@selected="selected"
				@selected-child="selectedChild"
				:checked="filterItem.statusTransaksi"
				:checked-child="filterItem.tahapan"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";
import SOFilterCheckboxSkeleton from "@/so-components/global/filter/skeleton/SOFilterCheckboxSkeleton";

export default {
	name: "SOFilterStatusTransaksi",
	components: {
		SOFilterTitle,
		SOInputCheckbox,
		SOFilterCheckboxSkeleton,
	},
	props: {
		id: String,
    dataOptions: {
      type: Array,
      default: function () {
        return [
          {
            id: "fstat-transaksi-5",
            value: "belum_selesai",
            title: "Belum Selesai",
            checked: false,
            titleBold: false,
          },
					{
						id: "fstat-transaksi-1",
						value: "order",
						title: "Order",
						checked: false,
						titleBold: false,
					},
					{
						id: "fstat-transaksi-2",
						value: "pengerjaan",
						title: "Pengerjaan",
						checked: false,
						titleBold: false,
						child: {
							name: "tahapan",
							data: []
						}
					},
					{
						id: "fstat-transaksi-3",
						value: "selesai_belum",
						title: "Selesai, belum diambil / diantar",
						checked: false,
						titleBold: false,
					},
					{
						id: "fstat-transaksi-4",
						value: "selesai_sudah",
						title: "Selesai, sudah diambil / diantar",
						checked: false,
						titleBold: false,
					},
				];
      }
    }
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		}),
		...mapGetters("metaModule", {
			tahapan: "getTahapan",
		})
	},
	data() {
		return {
			statusTransaksi: {
				name: "status-transaksi",
				data: []
			},
			pageSetting: {
				loading: false,
			},
			diterapkan: false,
		}
	},
	mounted() {
		this.diterapkan = this.filterItem.statusTransaksi.length > 0
		this.getTahapan()
	},
	methods: {
		async getTahapan() {
      await this.setDefaultOption();

			this.pageSetting.loading = true
			const res = await this.$store.dispatch("metaModule/fetchTahapan")
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.tahapan.forEach(v => {
        if (this.statusTransaksi.data[2].child) {
          this.statusTransaksi.data[2].child.data = [
            ...this.statusTransaksi.data[2].child.data,
            {
              id: "tahapan-" + v.idtahapan,
              value: v.idtahapan,
              title: v.nama,
              checked: false,
              titleBold: false,
            },
          ]
        }
			})
		},

    setDefaultOption() {
      this.statusTransaksi.data = this.dataOptions;
    },

		selected(val) {
			let temp = this.filterItem
			temp.statusTransaksi = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan = this.filterItem.statusTransaksi.length > 0
		},
		selectedChild(val) {
			// console.log("test", this.statusTransaksi.data[1].child.data.filter(v => val.includes(v.value) === true))
			let temp = this.filterItem
			temp.tahapan = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		},
	}
}
</script>